import { Endpoint } from '../endpoint';
import { FormId, CompactFormResponse } from '@business/entities/form';
import { ManagementFormTemplateResponse, CompactManagementFormTemplateResponse } from '@business/entities/managementFormTemplate';

export function fetchForms() {
  return Endpoint.get<CompactManagementFormTemplateResponse[]>(`@gc/management-form-template`);
}

export function fetchForm(id: FormId) {
  return Endpoint.get<ManagementFormTemplateResponse>(`@gc/management-form-template/form/${id}`);
}

export function createForm(data: Partial<ManagementFormTemplateResponse>) {
  return Endpoint.post<ManagementFormTemplateResponse>(`@gc/management-form-template`, { data });
}

export function updateForm(id: FormId, data: Partial<ManagementFormTemplateResponse>) {
  return Endpoint.patch<ManagementFormTemplateResponse>(`@gc/management-form-template/${id}`, { data });
}

export function deleteForm(id: FormId) {
  return Endpoint.delete<void>(`@gc/management-form-template/${id}`);
}

export function duplicateForm(id: FormId, data: Partial<ManagementFormTemplateResponse>) {
  return Endpoint.post<ManagementFormTemplateResponse>(`@gc/management-form-template/duplicate/${id}`, { data });
}

export function saveFormFields(id: FormId, data: Pick<ManagementFormTemplateResponse, 'fields'>) {
  return Endpoint.post<ManagementFormTemplateResponse>(`@gc/management-form-template/save-fields/${id}`, { data });
}

export function deleteFormShare(id: string) {
  return Endpoint.delete<void>(`@gc/management-form-template/delete-share/${id}`);
}
